module.exports = __webpack_public_path__ + "img/Rogue-nightelf-f-70.977fdc33.gif";